/*
  Convierte una fecha a string con formato "YYYY-MM-DD".
  Ejemplo: "2026-06-09T12:00:00" -> "2026-06-09"
*/
export const dateISOFormat = (value) => {
  if (!value || value === '0001-01-01T00:00:00') return '';

  try {
    // 1. Quitamos la 'T' y reemplazamos guiones por barras para asegurar hora local
    // "2026-02-03T00:00:00" -> "2026/02/03 00:00:00"
    const safeValue = value.toString()
      .replace('T', ' ')
      .replace(/-/g, '/');

    const date = new Date(safeValue);

    // 2. Si falló la conversión (Invalid Date), devolvemos vacío
    if (Number.isNaN(date.getTime())) return '';

    // 3. Formateamos usando sv-SE para obtener YYYY-MM-DD
    return new Intl.DateTimeFormat('sv-SE').format(date);
  } catch (error) {
    return '';
  }
};

/*
  Convierte una fecha a string con formato "dd/MM/yyyy".
  Ejemplo: "2026-06-09T12:00:00" -> "09/06/2026"
*/
export const dateFormat = (value, locales = 'en-GB') => {
  const style = {
    dateStyle: 'short',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

/*
  Convierte una fecha a string con formato "dd/MM".
  Ejemplo: "2026-06-09T12:00:00" -> "09/06"
*/
export const dateDDMMFormat = (value, locales = 'en-GB') => {
  const style = {
    day: '2-digit', month: '2-digit',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

/*
  Convierte una fecha a string con formato "dd/MM/yy".
  Ejemplo: "2026-06-09T12:00:00" -> "09/06/26"
*/
export const dateDDMMYYFormat = (value, locales = 'en-GB') => {
  const style = {
    day: '2-digit', month: '2-digit', year: '2-digit',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

/*
  Convierte una fecha a string con formato "dd/MM/yy, HH:mm".
  Ejemplo: "2026-06-09T12:00:00" -> "09/06/26, 12:00"
*/
export const dateDDMMYYHHMMFormat = (value, locales = 'en-GB') => {
  const style = {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

/*
  Convierte una fecha a string con formato "dd/MM/yy".
  Ejemplo: "2026-06-09T12:00:00" -> "09/06/26"
*/
export const dateMMYYFormat = (value, locales = 'en-GB') => {
  const style = {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

/*
  Convierte una fecha a string con formato "MMM" (abreviatura del mes).
  Ejemplo: "2026-06-09T12:00:00" -> "jun"
*/
export const dateMMFormat = (value, locales = 'es-PE') => {
  const style = {
    month: 'short',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value)).substring(0, 3);
};

/*
  Convierte una fecha a string con formato "dd" (día a dos dígitos).
  Ejemplo: "2026-06-09T12:00:00" -> "09"
*/
export const dateDDFormat = (value, locales = 'en-GB') => {
  const style = {
    day: '2-digit',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

/*
  Convierte una fecha a string con formato "dd/MM/yyyy, HH:mm".
  Ejemplo: "2026-06-09T12:00:00" -> "09/06/2026, 12:00"
*/
export const dateTimeFormat = (value, locales = 'en-GB') => {
  const style = {
    dateStyle: 'short',
    timeStyle: 'short',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

/*
  Convierte una fecha a string con formato "HH:mm:ss".
  Ejemplo: "2026-06-09T12:00:00" -> "12:00:00"
*/
export const timeFormat = (value, locales = 'en-GB') => {
  const style = {
    hour: 'numeric', minute: 'numeric', second: 'numeric',
  };

  return new Intl.DateTimeFormat(locales, style).format(new Date(value));
};

/*
  Convierte un objeto Date a string con formato "YYYY-MM-DDTHH:mm:ss".
  Ejemplo: new Date(2025, 10, 4) -> "2025-11-04T00:00:00"
*/
export const dateTimeString = (date) => {
  if (typeof date === 'string') {
    return date;
  }

  return `${date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).split('/').reverse().join('-')}T${date.toLocaleTimeString('en-GB')}`;
};
